import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { connect } from 'react-redux';
import memoizeOne from 'memoize-one';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { withStyles, CircularProgress } from '@material-ui/core';
import { RemoveRedEye as ViewIcon } from '@material-ui/icons';
import { FHETable, FHEContainer } from 'data/components';
import { Toastr, tools } from 'data/common';
import renderEnvComponent from 'data/common/renderEnvComponent';
import { getCraftsmanTickets } from '../../../data/Craftsman/actions';

class TableCraftsmanTickets extends PureComponent {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        getCraftsmanTickets: PropTypes.func.isRequired,
        profile: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        match: PropTypes.object.isRequired,
        needGetCraftsmanTicket: PropTypes.bool,
        managements: PropTypes.object.isRequired
    };

    static defaultProps = {
        needGetCraftsmanTicket: true
    };
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            tickets: {}
        };
    }
    componentDidMount() {
        const { needGetCraftsmanTicket } = this.props;
        if (needGetCraftsmanTicket) this.getCraftsmanTicket();
    }

    getCraftsmanTicket = () => {
        const { getCraftsmanTickets, match } = this.props;
        this.setState({
            loading: true
        });
        getCraftsmanTickets(match.params.craftsmanId)
            .then(data => {
                const newState = {
                    loading: false
                };
                if (data.success) {
                    newState.tickets = data.tickets;
                }
                this.setState(newState);
            })
            .catch(err => {
                const message = Translator.translateWithFallback(`api.message.${err.message ? err.message : err}`, 'api.message.default');
                Toastr.error(message);
                this.setState({
                    loading: false
                });
            });
    };

    navigateToDetail = rowData => {
        const { history } = this.props;
        return history.push({ pathname: `/${history.environment}/craftsman/ticket/${rowData.id}` });
    };

    renderData = memoizeOne((tickets, managements) => {
        const { history } = this.props;
        let result = [];

        Object.keys(tickets).map(ticketId => {
            const ticket = tickets[ticketId];
            result.push({
                id: parseInt(ticketId),
                homeId: parseInt(ticket.homeId),
                ref: ticket.ref,
                managementLabel: managements.getIn([ticket.managementId.toString(), 'libelle'], ''),
                assignmentLabel: ticket.assignment.label,
                type: ticket.type ? Translator.translate(`generic.ticketing.type.${ticket.type}`) : null,
                label: ticket.label,
                createdAt: ticket.createdAt,
                creatorLabel: ticket.creator.label,
                state: Translator.translate(`generic.ticketing.state.${ticket.state}`)
            });
        });
        return result;
    });

    renderActions = memoizeOne(profile => {
        const { history } = this.props;
        const userRights = profile.getIn(['user_rights', history.environment], []);

        let actions = {
            row: [],
            toolbar: []
        };
        if (profile.get('admin') || userRights.includes('ticketDetails')) {
            actions.row.push({
                icon: ViewIcon,
                onClick: this.navigateToDetail,
                tooltip: Translator.translate(`general.showDetail`)
            });
        }
        return actions;
    });

    renderColumns = memoizeOne(profile => {
        const { history } = this.props;
        return [
            {
                title: Translator.translate('general.table.column.homeId'),
                name: 'homeId'
            },
            {
                title: Translator.translate('general.table.column.label'),
                name: 'label',
                action: (profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes('ticketDetails')) && {
                    onClick: this.navigateToDetail,
                    tooltip: Translator.translate(`general.showDetail`)
                }
            },
            {
                title: Translator.translate('general.table.column.ref'),
                name: 'ref'
            },
            {
                title: Translator.translate('general.table.column.managementLabel'),
                name: 'managementLabel'
            },
            {
                title: Translator.translate('general.table.column.assignmentLabel'),
                name: 'assignmentLabel'
            },
            {
                title: Translator.translate('general.table.column.type'),
                name: 'type'
            },
            {
                title: Translator.translate('general.table.column.createdAt'),
                name: 'createdAt'
            },
            {
                title: Translator.translate('general.table.column.creatorLabel'),
                name: 'creatorLabel'
            },
            {
                title: Translator.translate('general.table.column.stateSimple'),
                name: 'state'
            }
        ];
    });

    renderTicket() {
        const { tickets } = this.state;
        const { profile, managements } = this.props;

        return (
            <FHETable
                idTable="craftsmanDetailTicket"
                columns={this.renderColumns(profile)}
                data={this.renderData(tickets, managements)}
                actions={this.renderActions(profile)}
                minified
            />
        );
    }

    render() {
        const { loading, tickets } = this.state;
        const { classes, history } = this.props;

        if (loading) {
            return (
                <FHEContainer>
                    <div className={classes.loadingContainer}>
                        <CircularProgress />
                    </div>
                </FHEContainer>
            );
        }

        return (
            <Fragment>
                {Object.keys(tickets).length > 0 ? this.renderTicket() : Translator.translate(`generic.ticketing.table.body.emptyDataSourceMessage`)}
            </Fragment>
        );
    }
}

function mapStateToProps(state, props) {
    const { history } = props;
    return {
        profile: state.data.user,
        managements: state.environments[history.environment].data.Managements.get('list')
    };
}

const styles = () => ({
    loadingContainer: {
        textAlign: 'center',
        margin: 20
    }
});

export default withRouter(
    renderEnvComponent(
        'scenes/Craftsman/Table/TableCraftsmanTickets.js',
        connect(
            mapStateToProps,
            (dispatch, ownProps) => bindActionCreators(tools.mergePropsToAction(ownProps.history.environment, { getCraftsmanTickets }), dispatch)
        )(withStyles(styles, { withTheme: true })(TableCraftsmanTickets))
    )
);



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/Craftsman/Table/TableCraftsmanTickets.js